import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    expandedRows: {
        threatHunting: {},
        introduced: {},
        resolved: {},
    },
    focusedRows: {
        threatHunting: null,
        introduced: null,
        resolved: null,
    },
};
export const issuesDiffSlice = createSlice({
    name: "issuesDiff",
    initialState: initialState,
    reducers: {
        focusedRowUpdated: (state, action) => {
            state.focusedRows[action.payload.dataType] = action.payload.id;
        },
        focusTamperingIssue: (state, action) => {
            state.expandedRows.threatHunting[action.payload] = true;
            state.focusedRows.threatHunting = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.dataType][action.payload.id] =
                    cloneDeep(initPagination);
            }
            else {
                delete state.expandedRows[action.payload.dataType][action.payload.id];
            }
        },
        expandedRowPaginationUpdated: (state, action) => {
            state.expandedRows[action.payload.dataType][action.payload.id] =
                action.payload.pagination;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "issuesDiff");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
    },
});
export const { focusTamperingIssue, expandedRowsUpdated, expandedRowPaginationUpdated, focusedRowUpdated, } = issuesDiffSlice.actions;
export const selectExpandedRow = (state, id, dataType) => state.report.issuesDiff.expandedRows[dataType][id] !== undefined;
export const selectExpandedRowPagination = (state, id, dataType) => { var _a; return (_a = state.report.issuesDiff.expandedRows[dataType][id]) !== null && _a !== void 0 ? _a : initPagination; };
export const selectFocusedRow = (state, dataType) => state.report.issuesDiff.focusedRows[dataType];
export const issuesDiffReducer = issuesDiffSlice.reducer;
export * as default from "./issuesDiffSlice";
//# sourceMappingURL=issuesDiffSlice.js.map